import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-offres',
  templateUrl: './offres.component.html',
  styleUrls: ['./offres.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class OffresComponent implements OnInit {
  isMobile = false;

  // --- Popup / Formulaire Contact ---
  showPopup = false;
  selectedOffreName = '';
  contactForm = {
    name: '',
    company: '',
    email: '',
    message: '',
  };

  successMessage: string = '';
  errorMessage: string = '';
  envoiEnCours = false; // Pour bloquer le bouton pendant l'envoi

  private ENDPOINT = 'https://us-central1-qaryos.cloudfunctions.net/sendContactMail';

  ngOnInit() {
    this.updateScreenMode();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateScreenMode();
  }

  private updateScreenMode() {
    this.isMobile = window.innerWidth < 768;
  }

  openPopup(offreName: string) {
    this.selectedOffreName = offreName;
    this.showPopup = true;
    this.contactForm = { name: '', company: '', email: '', message: '' };
    this.successMessage = '';
    this.errorMessage = '';
  }

  closePopup() {
    this.showPopup = false;
    this.envoiEnCours = false;
    this.successMessage = '';
    this.errorMessage = '';
  }

  async sendForm(event: Event) {
    event.preventDefault();
    if (this.envoiEnCours) return;

    // Validation minimale
    const { name, company, email, message } = this.contactForm;
    if (!name || !company || !email || !message) {
      this.errorMessage = 'Merci de compléter tous les champs obligatoires.';
      return;
    }

    this.envoiEnCours = true;
    this.successMessage = '';
    this.errorMessage = '';

    const payload = {
      name,
      company,
      email,
      message,
      offre: this.selectedOffreName,
    };

    try {
      const resp = await fetch(this.ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);

      this.successMessage =
        'Merci, votre message a bien été reçu. Nous revenons vers vous rapidement.';
      this.contactForm = { name: '', company: '', email: '', message: '' };
    } catch (err) {
      console.error('Erreur envoi formulaire:', err);
      this.errorMessage = "Erreur d'envoi. Le service est temporairement indisponible.";
    } finally {
      this.envoiEnCours = false;
    }
  }

  forceOpenOnDesktop(event: Event) {
    if (!this.isMobile) {
      const d = event.target as HTMLDetailsElement;
      if (!d.open) d.open = true; // on force l'état ouvert
    }
  }
}
